module.exports = __webpack_public_path__ + "img/garden_tech_Normal_ua.9bca33de.webp";